import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const categories = ['Desayunos', 'Almuerzos', 'Cenas', 'Postres', 'Picadas', 'Proteínas'];
const items = [{
  id: 1,
  cat: 'Picadas',
  name: 'Empanadas veganas doradas',
  emoji: '🥟',
  color: 'from-amber-700 to-amber-900'
}, {
  id: 2,
  cat: 'Almuerzos',
  name: 'Bowl de quinoa con verduras',
  emoji: '🥗',
  color: 'from-emerald-700 to-emerald-900'
}, {
  id: 3,
  cat: 'Proteínas',
  name: 'Hamburguesas de lentejas',
  emoji: '🍔',
  color: 'from-orange-700 to-orange-900'
}, {
  id: 4,
  cat: 'Postres',
  name: 'Alfajores veganos',
  emoji: '🍪',
  color: 'from-yellow-700 to-yellow-900'
}, {
  id: 5,
  cat: 'Cenas',
  name: 'Pizza fugazzeta vegana',
  emoji: '🍕',
  color: 'from-red-700 to-red-900'
}, {
  id: 6,
  cat: 'Postres',
  name: 'Torta de chocolate húmeda',
  emoji: '🍰',
  color: 'from-stone-700 to-stone-900'
}, {
  id: 7,
  cat: 'Desayunos',
  name: 'Panqueques de avena',
  emoji: '🥞',
  color: 'from-yellow-600 to-yellow-800'
}, {
  id: 8,
  cat: 'Desayunos',
  name: 'Tostadas con palta',
  emoji: '🥑',
  color: 'from-green-600 to-green-800'
}];
export function ExamplesCarousel() {
  const [activeCat, setActiveCat] = useState('Desayunos');
  // If a category has no items in our mock data, just show all to avoid empty states
  const filteredItems = items.filter(item => item.cat === activeCat).length > 0 ? items.filter(item => item.cat === activeCat) : items;
  return <section className="bg-[#0a0a0a] py-10 px-4 overflow-hidden" data-id="element-32">
      <div className="max-w-6xl mx-auto" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-35">
            Así se ven los platos de Cocina Veggie
          </h2>
          <p className="text-xl text-zinc-400" data-id="element-36">
            Cada receta incluye fotografía real del plato terminado
          </p>
        </motion.div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-37">
          {categories.map(cat => <button key={cat} onClick={() => setActiveCat(cat)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${activeCat === cat ? 'bg-emerald-600 text-white' : 'bg-zinc-900 text-zinc-400 hover:bg-zinc-800 hover:text-white'}`} data-id="element-38">
              {cat}
            </button>)}
        </div>

        {/* Carousel Area */}
        <div className="relative w-full overflow-x-auto pb-8 hide-scrollbar cursor-grab active:cursor-grabbing" data-id="element-39">
          <motion.div className="flex gap-6 w-max px-4 mx-auto" layout data-id="element-40">
            <AnimatePresence mode="popLayout" data-id="element-41">
              {filteredItems.map(item => <motion.div key={item.id} layout initial={{
              opacity: 0,
              scale: 0.8
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.8
            }} transition={{
              duration: 0.3
            }} className="w-72 flex-shrink-0 bg-[#18181b] border border-zinc-800 rounded-2xl overflow-hidden group" data-id="element-42">
                  {/* CSS Illustration placeholder for food */}
                  <div className={`h-48 w-full bg-gradient-to-br ${item.color} flex items-center justify-center relative overflow-hidden`} data-id="element-43">
                    <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-300" data-id="element-44"></div>
                    <span className="text-7xl filter drop-shadow-xl transform group-hover:scale-110 transition-transform duration-300" data-id="element-45">
                      {item.emoji}
                    </span>
                  </div>
                  <div className="p-6" data-id="element-46">
                    <span className="text-xs font-bold text-emerald-500 uppercase tracking-wider mb-2 block" data-id="element-47">
                      {item.cat}
                    </span>
                    <h3 className="text-lg font-bold text-white leading-tight" data-id="element-48">
                      {item.name}
                    </h3>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </section>;
}